import type { ReactNode } from 'react';
type Props = {
  title: string;
  children: ReactNode;
  /** Knoppen onder de tekst. */
  actions?: ReactNode;
  icon?: ReactNode;
  className?: string;
};

/**
 * Lege staat: zegt wat er (nog) niet is, waarom, en wat de logische volgende stap is.
 * Nooit alleen "Geen gegevens".
 */
export function EmptyCard({
  title,
  children,
  actions,
  icon,
  className = ''
}: Props) {
  return <div className={`bg-shell p-6 ring-1 ring-line sm:p-7 ${className}`} data-id="element-6254" data-mp="2acuwts1omf6r">
      {icon && <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-sand text-clay" aria-hidden="true" data-id="element-6255" data-mp="2fc7tt5m9p2n2">
          {icon}
        </span>}
      <p className="font-display text-[22px] leading-snug text-ink" data-id="element-6256" data-mp="20lh360wew9lj">{title}</p>
      <div className="mt-2 max-w-lg text-[15px] leading-relaxed text-muted" data-id="element-6257" data-mp="25l3fm84f1lta">{children}</div>
      {actions && <div className="mt-5 flex flex-wrap gap-2" data-id="element-6258" data-mp="2tao2h23ox37u">{actions}</div>}
    </div>;
}